import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementKmLocale from 'element-ui/lib/locale/lang/km'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import Avue from '@smallwei/avue'
import en from './en'
import km from './km'
import zh from './zh'

export default {
  en: {
    ...elementEnLocale,
    ...Avue.locale.en,
    ...en

  },
  km: {
    ...elementKmLocale,
    ...km

  },
  zh: {
    ...elementZhLocale,
    ...Avue.locale.zh,
    ...zh
  }
};
